import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { MdOutlineKeyboardArrowRight, MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { useAuthenticate } from "../context/AuthContext";

const SidemenuItem = ({ menuItem, isOpen, onToggle }) => {
  
  const { user } = useAuthenticate();

  

  return (
    <li className="mb-3 border-b border-gray-50">
      {!menuItem?.submenus ? (
        // Menu item without submenus
        <NavLink
          to={menuItem.path}
          className={({ isActive }) =>
            `flex items-center px-4 py-2  hover:bg-gray-100 transition-colors duration-200 ${
              isActive ? 'bg-blue-100 text-blue-600 border-r-2 border-blue-600' : 'text-gray-700'
            }`
          }
        >
          <div className="flex items-center justify-center w-5 h-5 mr-3 text-lg">
            {menuItem.icon}
          </div>
          <span className="font-medium">
            {menuItem.name}
          </span>
        </NavLink>
      ) : (
        // Menu item with submenus
        <>
          <div
            className="flex items-center justify-between px-4 py-2 hover:text-blue-600 text-gray-700 hover:bg-gray-100 cursor-pointer transition-colors duration-200"
            onClick={onToggle}
          >
            <div className="flex items-center">
              <div className="flex items-center justify-center w-5 h-5 mr-3 text-lg">
                {menuItem.icon}
              </div>
              <span className="font-medium">
                {menuItem.name}
              </span>
            </div>
            <div className={`transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}>
              {isOpen ? (
                <MdOutlineKeyboardArrowDown className="w-4 h-4" />
              ) : (
                <MdOutlineKeyboardArrowRight className="w-4 h-4" />
              )}
            </div>
          </div>

          {/* Submenu container with smooth animation */}
          <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
            <ul className="ml-8 mt-2 space-y-1">
              {menuItem?.submenus.map((submenu, index) => {
                // Check if user has permission for this submenu
                const hasPermission = !submenu?.permission || 
                  user?.permissions?.includes(submenu?.permission);

                return hasPermission ? (
                  <li key={`${submenu.path}-${index}`}>
                    <NavLink
                      to={submenu.path}
                      className={({ isActive }) =>
                        `block px-4 py-2 text-sm  hover:bg-gray-50 hover:text-blue-800 transition-colors duration-200 ${
                          isActive ? 'bg-blue-50 text-blue-600 font-medium border-r-2 border-blue-600' : 'text-gray-600'
                        }`
                      }
                    >
                      {submenu?.name}
                    </NavLink>
                  </li>
                ) : null;
              })}
            </ul>
          </div>
        </>
      )}
    </li>
  );
};

export default SidemenuItem;